import React from "react"

export const RuntimeContext = React.createContext<boolean>(false)
